<template>
  <div
    data-testid="section-title"
    class="mb-6 flex w-full justify-between border-l-4 border-p-500 text-xl md:pr-6 lg:mb-10 lg:text-3xl"
  >
    <h3 class="pl-2 font-bold capitalize text-s-900">
      {{ title }}
    </h3>
    <LinkWithAnimation
      v-if="!hideButton"
      :text="viewMoreText"
      class="flex-shrink-0 text-base font-semibold"
      :url="url"
      @click="$emit('viewMoreClick')"
    />
  </div>
</template>

<script setup lang="ts">
import LinkWithAnimation from '~/components/shared/common/LinkWithAnimation.vue'

withDefaults(
  defineProps<{
    viewMoreText?: string
    title: string
    url?: string
    hideButton?: boolean
  }>(),
  {
    viewMoreText: 'View More',
    url: '',
    hideButton: false,
  },
)
</script>
